import { defineCustomElement } from '@tyler-components-web/core';
import { OmnibarNotificationButtonComponent } from './omnibar-notification-button';
export * from './omnibar-notification-button-adapter';
export * from './omnibar-notification-button-constants';
export * from './omnibar-notification-button-foundation';
export * from './omnibar-notification-button';
export function defineOmnibarNotificationButtonComponent() {
    defineCustomElement(OmnibarNotificationButtonComponent);
}
